// Scripts to populate the therapists dropdown field
// And to do the find a therapist submission
// And to restrict checkbox selections
(function($) {
	/**
	 * Initial Appointment Form
	 */
	if ($('#gform_5').length) {
		//Listen for specific field changes
		//We will query the therapists when we have sufficient data
		$(document).on('change', 'li.service input, li.assessments select, li.treatments select, li.therapies input, li.locations select, li.languages input, li.insurance input, li.rate-ranges input, li.audiences select, li.availability select', getTherapists);

		function getTherapists() {
			//Get all the args
			let service_type = $('li.service input:checked').val();
			let assessment = $('li.assessments select').val();
			let treatment = $('li.treatments select').val();
			let location = $('li.locations select').val();
			let language = $('li.languages input:checked').val();
			let insurance_coverage = $('li.insurance input:checked').val();
			let rate_range = $('li.rate-ranges input:checked').val();
			let audience = $('li.audiences select').val();
			let availability = $('li.availability select').val();

			let therapies = [];
			$('li.therapies input:checked').each(function() {
				therapies.push($(this).val());
			});

			//Make sure we have all the things
			if (service_type && (assessment || treatment) && location && language && insurance_coverage && rate_range && audience && availability) {

				$.post('/wp-json/baytek/v1/therapist/appointment', {service_type, assessment, treatment, location, language, insurance_coverage, rate_range, audience, therapies, availability}, function(response) {
					if (response.options && response.options.length) {
						//Get the select
						let $select = $('li.available-therapists select');

						//Save the current selected value
						let val = $select.val();

						//Update the options
						$select.find('option:nth-child(n+2)').remove();
						$select.append(response.options.join(''));

						//Reselect the value
						if (val) {
							$select.val(val);
						}

						//If we have no more selected options, select the first one
						if (!$select.find('option:selected').length) {
							//Set the selected back to the placeholder
							$select.find('option').first().attr('selected', 'selected');
							$select.val('');
						}

						//If we don't have enough options, show the no matches message
						if (response.options.length <= 1) {
							$('li.available-therapists').next('.no-matches').removeClass('important-hidden');
						}
						//Otherwise, hide it
						else {
							$('li.available-therapists').next('.no-matches').addClass('important-hidden');
						}
					}
				})
				.always(function() {
					$('li.available-therapists').removeClass('important-hidden');
				});
			}
			//If we're missing something we need, hide the things
			else {
				$('li.available-therapists').addClass('important-hidden').val('');
				$('.no-matches').addClass('important-hidden');
			}
		}
	}

	/**
	 * Free Consultation Form
	 */
	if ($('#gform_6').length) {
		//Listen for therapist category changes, so we can claim/unclaim/hide drop-downs as needed
		$(document).on('change', 'li.categories input', function(e) {
			//Handle checking a new value
			if ($(this).is(':checked')) {
				//Find an unclaimed dropdown
				let $select = $('li.available-therapists select:not(.claimed)').first();

				//Claim it
				$select.addClass('claimed');
				$select.attr('data-category', $(this).val());

				//No need to show it, this will be handled by the fetching script
			}
			//Handle unchecking a selected value
			else {
				//Find the claimed dropdown
				let $select = $(`li.available-therapists select.claimed[data-category="${$(this).val()}"]`).first();

				if (!$select) return;

				//Unclaim it
				$select.removeClass('claimed');
				$select.attr('data-category', false);

				//Hide it again
				$select.parents('li.available-therapists').addClass('important-hidden');

				//Hide the no match message
				$select.parents('li.available-therapists').next('.no-matches').addClass('important-hidden');

				//Set the selected back to the placeholder
				$select.find('option').first().attr('selected', 'selected');
				$select.val('');
			}
		});

		//Listen for specific field changes
		//We will query the therapists when we have sufficient data
		$(document).on('change', 'li.locations select, li.audiences select, li.service input, li.assessments select, li.treatments input, li.categories input, li.availability select', getOtherTherapists);

		function getOtherTherapists() {
			//Get all the args
			let location = $('li.locations select').val();
			let audience = $('li.audiences select').val();
			let service_type = $('li.service input:checked').val();
			let assessment = $('li.assessments select').val();
			let availability = $('li.availability select').val();

			//Array values
			let treatment = [];
			$('li.treatments input:checked').each(function() {
				treatment.push($(this).val());
			});

			let categories = [];
			$('li.categories input:checked').each(function() {
				categories.push($(this).val());
			});

			//Make sure we have all the things
			if (location && audience && service_type && (assessment || treatment.length) && categories.length && availability) {
				//Build the argments (POST request to simplify the arrays)
				$.post('/wp-json/baytek/v1/therapist/consultation', {location, audience, service_type, assessment, treatment, categories, availability}, function(response) {

					//Now we do fiddly javascript to update two drop-down lists
					for (let i=0; i<response.length; i++) {
						//Get the claime drop-down
						let $select = $(`li.available-therapists select.claimed[data-category="${response[i].category}"]`).first();

						//No point continuing if we don't have it
						if (!$select) continue;

						//Fix it up nice and pretty
						$select.parents('li.available-therapists').find('label').html(response[i].label);

						//Save the current selected value
						let val = $select.val();

						//Put in the new options
						$select.find('option:nth-child(n+2)').remove();
						$select.append(response[i].options.join(''));

						//If we only found one match, show the no matches message
						if (response[i].options.length <= 1) {
							$select.parents('li.available-therapists').next('.no-matches').removeClass('important-hidden');
						}
						//Otherwise, hide it
						else {
							$select.parents('li.available-therapists').next('.no-matches').addClass('important-hidden');
						}

						//Reselect the value
						if (val) {
							$select.val(val);
						}

						//If we have no more selected options, select the first one
						if (!$select.find('option:selected').length) {
							//Set the selected back to the placeholder
							$select.find('option').first().attr('selected', 'selected');
							$select.val('');
						}
					}

				}).always(function() {
					//Show the claimed drop-downs
					$('select.claimed').parents('li.available-therapists').removeClass('important-hidden');
				});
			}
			//If we're missing something we need, hide the things
			else {
				$('li.available-therapists').addClass('important-hidden').val('');
				$('.no-matches').addClass('important-hidden');
			}
		}
	}

	/**
	 * Find A Therapist Form
	 */
	if ($('form#find-a-therapist').length) {
		$('#find-a-therapist #therapist-location').change(function(e) {
			$('form#find-a-therapist').attr('action', $(this).val());
		});
	}

	/**
	 * Checkbox Max Selections
	 */
	if ($('.gform_wrapper').length) {
		$(document).on('change', '.max-selections input', function(e) {
			//Get the maximum selections
			let $parent = $(this).parents('.max-selections');
			let matches = $parent.attr('class').match(/max-(\d)/);

			//Now check if we are over or under the max, and disable/enable inputs as needed
			if (matches.length) {
				let max = matches.pop();
				let count = $parent.find('input:checked').length;

				if (count >= max) {
					$parent.find('input:not(:checked)').attr('disabled', true);
				}
				else {
					$parent.find('input:disabled').attr('disabled', false);
				}
			}
		});
	}
})(jQuery);
